import Axios from 'axios';
import { API_KEY_JOBS, API_URL_JOBS } from '../constants';

export function updateBuilderBusiness(businessNumber, businessDetails) {
  const accessToken = localStorage.getItem('accessToken');

  const response = Axios({
    method: 'PUT',
    data: businessDetails,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_JOBS,
    },
    url: `${API_URL_JOBS}/users/${businessNumber}/businesses/${businessNumber}`,
  });
  return response;
}

export function createActivity(builderId, username, activityName) {
  // get the user profile
  const accessToken = localStorage.getItem('accessToken');

  const response = Axios({
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_JOBS,
    },
    data: {
      builderId,
      username,
      activityName,
    },
    url: `${API_URL_JOBS}/activityLog/admin`,
    validateStatus(status) {
      return status >= 200 && status <= 403; // default
    },
  });
  console.log({ response }, 'create actiivty');
  return response;
}
